import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiFunction } from "../utils/API";
import handleErrors from "../utils/handleErrors";
import "../assets/styles/productCategories.css";
import "../assets/styles/product.css";

const Subcategories = () => {
  const navigate = useNavigate();
  const { type, typeName } = useParams();
  const [subcategoryData, setSubcategoryData] = useState([]);

  useEffect(() => {
    const handleParams = async () => {
      try {
        if (!["category", "industry"].includes(type)) return navigate("/");

        const findCategory = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/category/find`,
          params: { categoryName: typeName },
        });

        if (!findCategory.data.found) return navigate("/");

        await apiFunction({
          method: "GET",
          endpoint: "frontend/subcategory",
          params: {
            apiParams: { page: 0, searchParams: "", sortingCols: [] },
            categoryId: findCategory.data.categoryInfo.categoryId,
          },
          setData: setSubcategoryData,
        });
      } catch (error) {
        console.log("Subcategories load error:", error);
        handleErrors({ error });
      }
    };
    handleParams();
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", paddingTop: "120px", paddingBottom: "60px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>

        <ol className="breadcrumb" style={{ marginBottom: "28px" }}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/category">Categories</Link></li>
          <li className="active">{typeName}</li>
        </ol>

        <h1 style={{ fontSize: "26px", fontWeight: 700, marginBottom: "32px", color: "#0f172a" }}>{typeName}</h1>

        <div className="pc-grid">
          <Link to={`/table/category/${typeName}/all`} style={{ textDecoration: "none" }}>
            <div className="pc-card" style={{ cursor: "pointer", textAlign: "center" }}>
              <div style={{ fontSize: "28px", marginBottom: "10px" }}>⊞</div>
              <h3 style={{ fontSize: "15px" }}>All Products</h3>
              <p style={{ fontSize: "13px", color: "#6b7280", margin: "6px 0 0" }}>Browse full category</p>
            </div>
          </Link>

          {subcategoryData.map((datum) => (
            <Link
              key={datum.subcatId}
              to={`/table/${type}/${typeName}/${datum.subcatName}`}
              style={{ textDecoration: "none" }}
            >
              <div className="pc-card" style={{ cursor: "pointer" }}>
                <h3 style={{ fontSize: "15px", fontWeight: 600, color: "#0f172a", marginBottom: "8px" }}>
                  {datum.subcatName}
                </h3>
                <span style={{ fontSize: "12px", color: "#034EA2", fontWeight: 500 }}>View products →</span>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Subcategories;
